var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 24,
    viewBox: "0 0 21 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 6H3.5M3.5 6H19.5M3.5 6V20C3.5 20.5304 3.71071 21.0391 4.08579 21.4142C4.46086 21.7893 4.96957 22 5.5 22H15.5C16.0304 22 16.5391 21.7893 16.9142 21.4142C17.2893 21.0391 17.5 20.5304 17.5 20V6M6.5 6V4C6.5 3.46957 6.71071 2.96086 7.08579 2.58579C7.46086 2.21071 7.96957 2 8.5 2H12.5C13.0304 2 13.5391 2.21071 13.9142 2.58579C14.2893 2.96086 14.5 3.46957 14.5 4V6M8.5 11V17M12.5 11V17",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.bc37be5992ca39e1f60efa562aa364a0.svg";
export { ForwardRef as ReactComponent };